import { cn } from "@gymflow/helpers";
import { DayProps } from "react-day-picker";

type DatePickerDayRedDotProps = { showRedDot: boolean } & DayProps;

export const DatePickerDayRedDot = ({
  day,
  modifiers,
  showRedDot,
  ...dayProps
}: DatePickerDayRedDotProps) => (
  <td {...dayProps} className={cn("relative", dayProps.className)}>
    {showRedDot && (
      <div className="bg-error-500 absolute right-1 top-1 size-1.5 rounded-full" />
    )}
    {dayProps.children}
  </td>
);
